import { Pattern, RegisterPattern } from "../../Pattern"

RegisterPattern(Pattern.ParsePatFile(`
*LINE,LINE
0, 0,0, 0,.125
`), false)
